<template>
  <div>
    <v-text-field
      :name="name"
      :type="type"
      :label="label"
      :placeholder="placeholder"
      v-model="localValue"
      @change="inputCallback"
      @input="inputCallback"
      dense
      outlined
      :readonly="readonly"
      :disabled="readonly"
      v-bind="$attrs"
    />
  </div>
</template>
<script>
export default {
  name: "DateInputComponent",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
      default: "Salvar",
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    validation: {
      type: String,
    },
    value: {},

    readonly: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      localValue: this.value
    }
  },

  watch: {
    value(newVal) {
      this.localValue = newVal
    }
  },

  methods: {
    inputCallback(value) {
      this.$emit('input', value)
      this.$emit('update', value)
      this.$emit('validation', { hasErrors: false })
    }
  }
};
</script>